const reduxActionTypePrefix = "notification";
const linkTextDefault = "Learn more";
const footerButtonTextDefault = "Action";
const pageSizeDefault = 10;
const pollIntervalInMilliSecond = 30 * 1e3;
const helpLink = "https://aka.ms/exp/help";
var reduxKeys = /* @__PURE__ */ ((reduxKeys2) => {
  reduxKeys2["items"] = "items";
  reduxKeys2["value"] = "value";
  return reduxKeys2;
})(reduxKeys || {});
var NOTIFICATION_EVENT_TYPES = /* @__PURE__ */ ((NOTIFICATION_EVENT_TYPES2) => {
  NOTIFICATION_EVENT_TYPES2["panelOpen"] = "NOTIFICATION_EVENT_PANEL_OPEN";
  NOTIFICATION_EVENT_TYPES2["refreshWithNew"] = "NOTIFICATION_EVENT_REFRESH_WITH_NEW";
  NOTIFICATION_EVENT_TYPES2["bodyLinkClick"] = "NOTIFICATION_EVENT_BODY_LINK_CLICK";
  NOTIFICATION_EVENT_TYPES2["footerButtonClick"] = "NOTIFICATION_EVENT_FOOTER_BUTTON_CLICK";
  NOTIFICATION_EVENT_TYPES2["dismissAllConfirm"] = "NOTIFICATION_EVENT_DISMISSALL_CONFIRM";
  NOTIFICATION_EVENT_TYPES2["dismissSingle"] = "NOTIFICATION_EVENT_DISMISS_SINGLE";
  NOTIFICATION_EVENT_TYPES2["loadMoreClick"] = "NOTIFICATION_EVENT_LOADMORE_CLICK";
  NOTIFICATION_EVENT_TYPES2["pollPeriodically"] = "NOTIFICATION_EVENT_POLL_PERIODICALLY";
  NOTIFICATION_EVENT_TYPES2["pollStop"] = "NOTIFICATION_EVENT_POLL_STOP";
  NOTIFICATION_EVENT_TYPES2["loadDataSuccess"] = "NOTIFICATION_EVENT_LOADDATA_SUCCESS";
  NOTIFICATION_EVENT_TYPES2["loadDataFailed"] = "NOTIFICATION_EVENT_LOADDATA_FAILED";
  return NOTIFICATION_EVENT_TYPES2;
})(NOTIFICATION_EVENT_TYPES || {});
const ViewConstants = {
  empty: {
    headerText: `You're all caught up with notifications`,
    footerText: "When you get more, they will be there"
  },
  noAccess: {
    headerText: "No access, you need an Experimentation Reader role",
    footerText: "If the permission has been granted just now, please wait a while and try again"
  },
  error: {
    headerText: "Something went wrong",
    footerText: "If you require technical support, please "
  }
};
export {
  NOTIFICATION_EVENT_TYPES,
  ViewConstants,
  footerButtonTextDefault,
  helpLink,
  linkTextDefault,
  pageSizeDefault,
  pollIntervalInMilliSecond,
  reduxActionTypePrefix,
  reduxKeys
};
//# sourceMappingURL=constants.js.map
